// angular
//     .module("HeroPRO")
//     .controller("AddOfficeController", addOfficeController);

import _ from 'lodash';

import './addOffice.scss';
import './addContactInfo/addContactInfo.scss';
import './addOfficeInfo/addOfficeInfo.scss';
import './addOfficePaymentInfo/addOfficePaymentInfo.scss';
import './addOfficeProfile/addOfficeProfile.scss';


/* @ngInject */
export default function addOfficeController($uibModalInstance, $window, $rootScope, OfficesFactory, HPConfig, UserData, $sce, HPRoles, DirectiveService, $analytics, CommonDataFactory) {
    const vm = this;
    vm.contentShown = 'addOfficeInProgress';
    vm.enableValidation = 'false';
    vm.maxDescriptionLength = 900;
    vm.orgId = -1;
    vm.currentStep = {};
    vm.leadContact = {};
    vm.scrollToTop = false;
    vm.saving = false;
    vm.leadSameAsContact = false;

    vm.addACHEnabled = false;


    vm.steps = [
        {
            id: 0,
            title: 'Office Info',
            defaultBtnText: 'Next',
            isCompleted: false,
            isActive: true,
            isVisited: false,
            primaryBtnText: 'Cancel',
            path: 'app/accounts/offices/addOffice/addOfficeInfo/addOfficeInfo.html',
        },
        {
            id: 1,
            title: 'Contact Info',
            defaultBtnText: 'Next',
            isCompleted: false,
            isActive: false,
            isVisited: false,
            primaryBtnText: 'Previous',
            path: 'app/accounts/offices/addOffice/addContactInfo/addContactInfo.html',
        },
        /*
        {
            id: 2,
            title: 'Payment Info',
            defaultBtnText: 'Next',
            isCompleted: false,
            isActive: false,
            isVisited: false,
            primaryBtnText: 'Previous',
            path: 'app/accounts/offices/addOffice/addOfficePaymentInfo/addOfficePaymentInfo.html',
        },
        */{
            id: 2,
            title: 'Office Profile',
            defaultBtnText: 'Finish',
            isCompleted: false,
            isActive: false,
            isVisited: false,
            primaryBtnText: 'Previous',
            path: 'app/accounts/offices/addOffice/addOfficeProfile/addOfficeProfile.html',
        }];

    vm.officeName = '';
    vm.contactFirstName = '';
    vm.contactLastName = '';
    vm.officeWebsite = '';
    vm.officeDescription = '';
    vm.fullCountyList = [];

    vm.defaultServiceType = {
        Description: 'Choose one',
        Name: 'null',
        ContractorTypeId: -1,
    };

    vm.defaultAccountType = {
        BankAccountTypeId: -1,
        Name: 'null',
        Description: 'Choose one',
    };

    vm.address = {
        street: '',
        city: '',
        state: '',
        zip: '',
    };

    vm.contact = {
        Email: '',
        PhoneNumber: '',
        Extension: '',
    };

    vm.profileDetail = {
        CompanyOverview: '',
        CompanyURL: '',
    };

    // Logo
    vm.logoImage = null;
    vm.logoFileName = '';
    vm.displayLogo = null;

    // Errors
    vm.description = '';
    vm.uploadErrorMessage = '';
    vm.countiesErrorMessage = '';

    // states
    vm.states = [];
    vm.selectedState = null;
    let allStates = [];

    // Counties/Municipalities
    vm.counties = [];
    vm.currentCounties = [];

    // Primary Service
    vm.selectedPrimaryService = null;

    // Additional Services
    vm.primaryService = {};
    vm.secondaryServices = [];
    vm.availableServices = [];
    vm.contractorServiceTypes = [];

    // Payment Info
    vm.selectedAccountType = {};
    vm.accountTypes = [];
    vm.verifyAccountNumber = '';
    vm.LocationACH = {
        ACHBank: '',
        ACHRoutingNumber: '',
        ACHAccountNumber: '',
    };
    vm.mainOfficeACH = {};
    vm.content = '<img class="hero-check" src="src/assets/images/hero-check-sample.jpg" alt="Sample Check">';
    const trusted = {};
    vm.displayApprovalBadge = false;
    vm.useMainACH = false;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
    vm.updateLeadContact = function () {
        if (vm.leadSameAsContact) {
            vm.leadContact = vm.contact;
            vm.leadContact.contactFirstName = vm.contactFirstName;
            vm.leadContact.contactLastName = vm.contactLastName;
        }
    };
    vm.sameAsContactInfo = function () {
        if (vm.leadSameAsContact) {
            vm.leadContact = vm.contact;
            vm.leadContact.contactFirstName = vm.contactFirstName;
            vm.leadContact.contactLastName = vm.contactLastName;
        } else {
            vm.leadContact = {};
        }
    };

    vm.closeModal = function () {
        let result = false;

        if (vm.contentShown === 'addOfficeSuccess') {
            result = true;
        }

        $uibModalInstance.close(result);
        vm.contentShown = 'addOfficeInProgress';
        vm.submitted = false;
    };

    vm.navigateProgress = function (step) {
        if (step.isVisited === true) {
            if (step.id > vm.currentStep.id) {
                vm.addNewOffice.$setSubmitted();
                vm.submitted = 'true';

                validateStep(vm.currentStep.id);
                if (vm.addNewOffice.$valid) {
                    processStep(vm.currentStep.id, step.id, null);
                }
            } else {
                processStep(vm.currentStep.id, step.id, null);
            }
        }
    };

    vm.defaultBtnClick = function (event) {
        event.preventDefault();
        vm.scrollToTop = true;
        processStep(vm.currentStep.id, vm.currentStep.id - 1, event);
    };

    vm.setFieldRequiredState = function () {
        return (!vm.addNewOffice.$submitted).toString();
    };

    vm.openContractorPage = function () {
        $window.open(
            `${HPConfig.renovateLink}/find-a-contractor`,
            '_blank',
        );
    };

    vm.accountTypeClicked = function (type) {
        vm.selectedAccountType = type;
        if (hasAccountType()) {
            vm.LocationACH.ACHBankAccountTypeId = vm.selectedAccountType.BankAccountTypeId;
        }
        validateAccountType();
    };

    vm.submitForm = function (event) {
        vm.submitted = 'true';
        validateStep(vm.currentStep.id);
        if (vm.addNewOffice.$valid && vm.saving !== true) {
            processStep(vm.currentStep.id, vm.currentStep.id + 1, event);
        }
    };

    vm.calcCharactersRemaining = function () {
        if (vm.officeDescription !== undefined && vm.officeDescription !== null && vm.officeDescription !== '') {
            return vm.maxDescriptionLength - vm.officeDescription.replace(/\n/g, '\r\n').length;
        }
        return vm.maxDescriptionLength;
    };

    vm.selectCounty = function (selectedCounty) {
        let county = _.find(vm.counties[0], item => item.MuniId === selectedCounty.MuniId);
        if (county !== null && county !== undefined) {
            county.isSelected = !county.isSelected;
        } else {
            county = _.find(vm.counties[1], item => item.MuniId === selectedCounty.MuniId);
            if (county !== null && county !== undefined) {
                county.isSelected = !county.isSelected;
            }
        }
    };

    vm.primaryServiceClicked = function (service) {
        service.isSelected = true;
        vm.addNewOffice.$setValidity('noservicetype', true);
        vm.selectedPrimaryService = service;
        vm.contractorServiceTypes = _.without(vm.contractorServiceTypes, vm.defaultServiceType);
        vm.availableServices = _.without(
            vm.contractorServiceTypes,
            _.findWhere(vm.contractorServiceTypes, vm.selectedPrimaryService),
        );

        // Check if selected primary is a secondary
        const secService = _.find(vm.secondaryServices, secSvc => secSvc.ContractorTypeId === service.ContractorTypeId);

        if (secService !== undefined && secService !== null) {
            vm.secondaryServices = _.without(vm.secondaryServices, secService);
        }

        _.each(vm.secondaryServices, (secSvc) => {
            vm.availableServices = _.without(vm.availableServices, _.find(vm.availableServices, service => service.ContractorTypeId === secSvc.ContractorTypeId));
        });
    };

    vm.addService = function () {
        vm.secondaryServices.push(vm.defaultServiceType);
    };

    vm.secondaryServiceClicked = function (type, index) {
        vm.secondaryServices[index] = type;
        vm.availableServices = _.map(vm.contractorServiceTypes, _.clone);
        vm.availableServices = _.without(
            vm.availableServices,
            _.findWhere(vm.availableServices, vm.selectedPrimaryService),
        );
        // Rebuild available list
        _.each(vm.secondaryServices, (selSvc) => {
            vm.availableServices = _.without(vm.availableServices, _.findWhere(vm.availableServices, selSvc));
        });
    };

    vm.removeService = function (type) {
        vm.secondaryServices = _.without(vm.secondaryServices, _.findWhere(vm.secondaryServices, type));
        vm.availableServices = _.map(vm.contractorServiceTypes, _.clone);
        vm.availableServices = _.without(
            vm.availableServices,
            _.findWhere(vm.availableServices, vm.selectedPrimaryService),
        );
        // Rebuild available list
        _.each(vm.secondaryServices, (selSvc) => {
            vm.availableServices = _.without(vm.availableServices, _.findWhere(vm.availableServices, selSvc));
        });
        vm.availableServices = _.sortBy(vm.availableServices, 'ContractorTypeId');
    };

    vm.checkAccountNumber = function () {
        vm.isEditAccountNumber = true;
        vm.checkAccountNumberChange();
    };

    vm.checkAccountNumberChange = function () {
        if (vm.verifyAccountNumber && vm.LocationACH.ACHAccountNumber !== vm.verifyAccountNumber) {
            vm.addNewOffice.txtAccountNumber.$setValidity('nomatch', false);
            if (vm.addNewOffice.txtVerifyAccountNumber !== undefined) {
                vm.addNewOffice.txtVerifyAccountNumber.$setValidity('nomatch', false);
            }
            vm.errorMessage = 'Account Numbers do not match';
            vm.isAcctNumberConfirmed = false;
        } else {
            vm.addNewOffice.txtAccountNumber.$setValidity('nomatch', true);
            if (vm.addNewOffice.txtVerifyAccountNumber !== undefined) {
                vm.addNewOffice.txtVerifyAccountNumber.$setValidity('nomatch', true);
            }
            vm.errorMessage = '';
            if (vm.LocationACH.ACHAccountNumber === vm.verifyAccountNumber && vm.addNewOffice.$valid) {
                vm.isAcctNumberConfirmed = true;
            }
        }

        if (vm.addNewOffice.$invalid) {
            vm.isAcctNumberConfirmed = false;
        }
    };

    vm.getExampleCheck = function (content) {
        return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
    };

    vm.selectCopyPaymentInfo = function () {
        vm.useMainACH = !vm.useMainACH;
        if (vm.useMainACH) {
            //			getMainInfo();
            vm.LocationACH = _.extend({}, vm.mainOfficeACH);
            const loadedType = _.filter(vm.accountTypes, type => type.BankAccountTypeId === vm.mainOfficeACH.ACHBankAccountTypeId);
            vm.selectedAccountType = loadedType[0];
            vm.errorMessage = '';

            // Clear validation when copying Payment Info from Main. (This is needed when validation is triggered, then the user selects the checkbox.
            vm.addNewOffice.$setValidity('nocheck', true);
            vm.addNewOffice.$setValidity('noaccounttype', true);
        } else {
            // Don't need to setValidity, since formValidation is always triggered before advancing steps. This code clears out field values.
            vm.LocationACH = {
                ACHBank: '',
                ACHRoutingNumber: '',
                ACHAccountNumber: '',
            };
            vm.verifyAccountNumber = '';
            vm.selectedAccountType = vm.accountTypes[0];
        }
    };

    vm.checkState = function () {
        let activeState;

        if (vm.selectedState !== null) {
            activeState = _.filter(vm.states, state => state.StateGeoId === vm.selectedState.StateGeoId);
        }

        // Added condition to check activeState length. Filter returns an empty array if no records match condition.
        // Refactored condition to return condition rather than explicit true/false
        return (vm.selectedState !== null && activeState !== undefined && activeState.length > 0);
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions           =
	 ======================================== */
    function init() {
        getCurrentLocation();
        vm.submitted = 'false';
        vm.currentStep = vm.steps[0];

        $rootScope.$on('HPFileUploaded', (event, args, file) => {
            vm.LocationACH.VoidedCheckFileName = file.name;
            vm.LocationACH.VoidedCheckTempFileKey = file.tempFileKey;
            vm.displayApprovalBadge = true;
            $rootScope.$apply();
        });
    }

    function getCurrentLocation() {
        UserData.getCurrentLocation().then((response) => {
            vm.orgId = response.OrganizationId;
            getContractorServices();
            getActiveStates();
            getAccountTypes();
            getUserRights();
        });
    }

    function getUserRights() {
        UserData.getUserData().then((response) => {
            const currentRole = _.find(HPRoles, (key, other) => other === response.Roles[0]);

            vm.isAdmin = !!currentRole && currentRole.rank === 1;
            if (vm.isAdmin) {
                getMainInfo();
            } else {
                vm.useMainACH = true;
            }
        });
    }

    function getMainInfo() {
        const data = {};

        data.IncludeACHInfo = vm.isAdmin;
        UserData.getMainLocation().then((response) => {
            data.ContractorLocationId = response[0].ContractorId;
            data.ExcludeLocationInfo = true;
            data.ExcludeProfileInfo = true;
            data.IncludeACHInfo = true;

            OfficesFactory.getOfficeProfile(data).then((response) => {
                vm.mainOfficeACH = response.data.PaymentDetail;
                if (!vm.mainOfficeACH || !vm.mainOfficeACH.ACHBankAccountTypeId) {
                    vm.mainOfficeACH = null;
                    vm.LocationACH = {
                        ACHBank: '',
                        ACHRoutingNumber: '',
                        ACHAccountNumber: '',
                    };
                    vm.verifyAccountNumber = '';
                    vm.selectedAccountType = vm.accountTypes[0];
                }
            });
        });
    }

    function getContractorServices() {
        OfficesFactory.getServices().then((response) => {
            vm.contractorServiceTypes = response.data.Data;
            if (_.findWhere(vm.contractorServiceTypes, { ContractorTypeId: -1 }) === undefined) {
                vm.contractorServiceTypes.unshift(vm.defaultServiceType);
            }
            vm.selectedPrimaryService = vm.contractorServiceTypes[0];
            vm.availableServices = vm.contractorServiceTypes;
        });
    }

    // temp. replacing vm.states with all states. also flipped flag from active to all i.e. false
    function getActiveStates() {
        CommonDataFactory.getStates(true).then((response) => {
            allStates = response.data.Data;
            // vm.states = _.filter(allStates, function (state) {
            //	return state.StateGeoId === 6;
            // });
            vm.states = response.data.Data;
            const state = _.filter(allStates, state => state.StateAbbreviation === vm.address.state);

            if (state.length > 0) {
                vm.selectedState = state[0];
                getCounties(vm.selectedState);
            }
        });
    }

    /* modified. needs to be reverted. e */
    function getCounties(state) {
        if (state === null || angular.isUndefined(state.StateGeoId)) {

        } else if (vm.fullCountyList.length === 0 || (vm.fullCountyList.length === 1 && state.StateGeoId === 6)) {
            OfficesFactory.getCounties().then((response) => {
                vm.fullCountyList = _.each(_.sortBy(response.data.Data.Munis, 'Name'), item => _.extend(item, { isSelected: false }));
                formatCounties(getCountiesByState(state));
            });
        } else {
            formatCounties(getCountiesByState(state));
        }
    }

    function getCountiesByState(state) {
        return _.filter(vm.fullCountyList, f => angular.equals(f.FIPSCode.substring(0, 2), state.StateFIPSPrefix));
    }

    function formatCounties(counties) {
        vm.counties = [];
        const firstHalfCounties = counties.slice(0, counties.length / 2);
        const secondHalfCounties = counties.slice(counties.length / 2);
        vm.counties.push(firstHalfCounties);
        vm.counties.push(secondHalfCounties);
    }

    function getAccountTypes() {
        OfficesFactory.getAccountTypes().then((response) => {
            vm.accountTypes = response;
            if (_.findWhere(vm.accountTypes, { BankAccountTypeId: -1 }) === undefined) {
                vm.accountTypes.unshift(vm.defaultAccountType);
            }
            vm.selectedAccountType = vm.accountTypes[0];
        });
    }

    function prepServicesForSave() {
        const currentSelectedServices = [];
        _.each(vm.secondaryServices, (service) => {
            if (service.ContractorTypeId !== undefined && service.ContractorTypeId !== null && service.ContractorTypeId !== -1) {
                currentSelectedServices.push({
                    ContractorTypeId: service.ContractorTypeId,
                    IsPrimaryType: false,
                });
            }
        });
        currentSelectedServices.push({
            ContractorTypeId: vm.selectedPrimaryService.ContractorTypeId,
            IsPrimaryType: true,
        });
        return currentSelectedServices;
    }

    function prepMunisForSave() {
        // var munis = vm.counties[0].slice();
        // munis.push.apply(munis, vm.counties[1]);
        const filteredMunis = _.filter(vm.fullCountyList, muni => muni.isSelected === true);
        const currentMunis = [];
        _.each(filteredMunis, (muni) => {
            currentMunis.push({ MuniId: muni.MuniId });
        });
        return currentMunis;
    }

    function hasPrimaryService() {
        if (vm.selectedPrimaryService.ContractorTypeId === -1) {
            return false;
        }

        return true;
    }

    function validatePrimaryService() {
        if (hasPrimaryService()) {
            vm.addNewOffice.$setValidity('noservicetype', true);
        } else {
            vm.addNewOffice.$setValidity('noservicetype', false);
        }
    }

    function hasState() {
        if (vm.address.state) {
            return true;
        }

        return false;
    }

    function validateState() {
        if (hasState()) {
            vm.addNewOffice.$setValidity('nostate', true);
        } else {
            vm.addNewOffice.$setValidity('nostate', false);
        }
    }

    function hasAccountType() {
        if (!vm.selectedAccountType || vm.selectedAccountType.BankAccountTypeId === -1) {
            return false;
        }

        return true;
    }

    function validateAccountType() {
        if (hasAccountType()) {
            vm.addNewOffice.$setValidity('noaccounttype', true);
        } else {
            vm.addNewOffice.$setValidity('noaccounttype', false);
        }
    }

    function hasCheck() {
        if (vm.LocationACH.VoidedCheckTempFileKey === undefined || vm.LocationACH.VoidedCheckFileName === undefined) {
            return false;
        }

        return true;
    }

    function validateCheck() {
        if (hasCheck()) {
            vm.addNewOffice.$setValidity('nocheck', true);
        } else {
            vm.addNewOffice.$setValidity('nocheck', false);
        }
    }

    function validateStep(id) {
        vm.scrollToTop = false;
        switch (id) {
        case 0:
            validateState();
            break;
        case 1:
            break;
            /*
        case 2:
            if (!vm.useMainACH) {
                validateAccountType();
                validateCheck();
            }
            break;
            */
        default:
            validatePrimaryService();
            break;
        }
    }

    function clearValidation(id) {
        switch (id) {
        case 0:
            vm.addNewOffice.$setValidity('nostate', true);
            break;
        case 1:
            vm.addNewOffice.$setValidity('noaccounttype', true);
            vm.addNewOffice.$setValidity('nocheck', true);
            break;
        default:
            vm.countiesErrorMessage = '';
            vm.addNewOffice.$setValidity('noservicetype', true);
            break;
        }
    }

    function processStep(fromId, toId, event) {
        switch (fromId) {
        case 0:
            if (fromId > toId) {
                vm.closeModal();
                break;
            } else {
                moveStep(fromId, toId);
            }
            if (event) {
                event.preventDefault();
            }
            break;
        case 1:
        // case 2:
            if (fromId > toId) {
                moveStep(fromId, toId);
            } else {
                moveStep(fromId, toId);
            }
            if (event) {
                event.preventDefault();
            }
            break;
        default:
            if (fromId > toId) {
                moveStep(fromId, toId);
            } else {
                vm.saving = true;
                const data = {
                    OrganizationId: vm.orgId,
                    LocationDetail: {
                        LocationNickname: vm.officeName,
                        Address: vm.address.street,
                        City: vm.address.city,
                        State: vm.address.state,
                        Zip: vm.address.zip,
                    },
                    ProfileDetail: {
                        CompanyOverview: vm.officeDescription,
                        CompanyURL: vm.officeWebsite,
                        LogoFilename: vm.logoFileName,
                        ContractorTypes: prepServicesForSave(),
                        Munis: prepMunisForSave(),
                    },
                    LocationACH: vm.LocationACH,
                    LocationContact: {
                        OfficeContactFirstName: vm.contactFirstName,
                        OfficeContactLastName: vm.contactLastName,
                        OfficeContactPhone: vm.contact.PhoneNumber,
                        OfficeContactPhoneExtension: vm.contact.Extension,
                        OfficeContactEmail: vm.contact.Email,
                        LeadContacts: [
                            {
                                FirstName: vm.leadContact.contactFirstName,
                                LastName: vm.leadContact.contactLastName,
                                Email: vm.leadContact.Email,
                                Phone: vm.leadContact.PhoneNumber,
                                Extension: vm.leadContact.Extension,
                            },
                        ],
                    },
                };

                // if (vm.useMainACH || !vm.isAdmin) {
                data.CopyACHFromMasterLocation = true;
                data.LocationACH = null;
                // }

                saveNewOffice(data);
            }
            break;
        }
    }

    function saveNewOffice(data) {
        OfficesFactory.saveNewOffice(data).then(() => {
            vm.saving = false;
            vm.successText = `${vm.officeName} office has been added successfully!`;
            vm.contentShown = 'addOfficeSuccess';
            UserData.resetPromises().then(() => {
                $rootScope.$broadcast('officesUpdated');
            });
        });
    }

    function moveStep(fromId, toId) {
        if (fromId > toId) {
            // Backward
            vm.steps[fromId].isVisited = true;
            vm.steps[fromId].isActive = false;
            vm.steps[toId].isVisited = false;
            vm.steps[toId].isActive = true;
            clearValidation(fromId);
        } else {
            // Forward
            vm.steps[fromId].isVisited = true;
            vm.steps[fromId].isCompleted = true;
            vm.steps[fromId].isActive = false;
            vm.steps[toId].isActive = true;
            vm.steps[toId].isVisited = false;
        }
        vm.currentStep = vm.steps[toId];
        DirectiveService.publish('scroll');
        vm.addNewOffice.$setPristine();
        vm.submitted = 'false';
    }


    $rootScope.$watch(() => vm.logoImage, (val) => {
        if (val !== undefined && val !== null) {
            vm.uploadErrorMessage = '';
            vm.displayLogo = true;
        }
    });
    /* modified used allStates instead of vm.states */
    $rootScope.$watch(() => vm.address.state, (val, oldval) => {
        if (!angular.equals(val, oldval)) {
            const state = _.find(allStates, s => s.StateAbbreviation === val);
            vm.selectedState = angular.isUndefined(state) ? null : state;
        }
    });
    /* modified used allStates instead of vm.states */
    $rootScope.$watch(() => vm.selectedState, (val, oldval) => {
        if (!angular.equals(val, oldval)) {
            if (val === null) {
                vm.counties = [];
                return;
            }
            const state = _.find(allStates, s => s === val);
            if (angular.isUndefined(state)) {
                return;
            }
            getCounties(vm.selectedState);
        }
    });

    $rootScope.$on('addLogoInvalidUploadType', (event, payload) => {
        vm.uploadErrorMessage = 'That file is not a jpeg, jpg, tiff, gif, bmp, or png.';
        $analytics.eventTrack(
            'Invalid Logo Upload',
            { category: 'Add Office', label: `File Extension: ${payload.fileType}` },
        );
    });

    $rootScope.$on('addLogoInvalidUploadSize', () => {
        vm.uploadErrorMessage = 'That file is larger than 10 MB.';
    });

    $rootScope.$on('addLogoStartUpload', (event, payload) => {
        OfficesFactory.saveLogo(payload).then((response) => {
            vm.logoImage = HPConfig.rackspaceCdn + response.data.Data.FileName;
            vm.logoFileName = response.data.Data.FileName;
            vm.uploadErrorMessage = '';
        });
    });

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/addOffice/addOfficeController.js